import React, { useEffect, useRef, useState } from 'react';

import { Container, Button, Dropdown, DropdownButton, Alert, Col, Row, Spinner, OverlayTrigger, Tooltip, Toast, ToastContainer } from 'react-bootstrap';
import * as sanitizeHtml from 'sanitize-html';
import showdown from "showdown";
import './HtmlReader.scss';


const HtmlReader = (props) => {
    const converter = new showdown.Converter();

    return (
        <div id="HtmlReader" dangerouslySetInnerHTML={{ __html: sanitizeHtml(converter.makeHtml(props.htmlData)) }} />
    )

}

export default HtmlReader;